import(/* webpackMode: "eager", webpackExports: ["LearnSyllabus"] */ "/vercel/path0/features/learn/components/LearnSyllabus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LearnTrackAside"] */ "/vercel/path0/features/learn/components/LearnTrackAside.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LearnTrackPriceChip"] */ "/vercel/path0/features/learn/components/LearnTrackPriceChip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LearnProPrices"] */ "/vercel/path0/features/learn/pro/LearnProPrices.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
